//====================== auth ====================
export const checkUserApi="/check-user"
export const userRegisterApi="/user-register"
export const checkReferralUrlApi="/check-referral-url"

//================= stage ===============
export const getStageApi="/get-stage"
export const tokenRaisedApi="/get-token-raised"

//================ transaction ===================
export const addTransactinApi="/add-transaction"
export const getTransactionApi="/get-transaction"
export const getUsertokenApi="/get-user-token"

//================== Dashboard =================
export const getUserDashboardApi="/get-user-dashboard"

//============== additional ==================
export const getLiveTokenDateApi="/additional-live-token-date"

//==================== Claim =================
export const getClaimTokenApi="/get-claim-token"
export const addClaimTokenapi="/claim-token"